import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { ROW_GAP_MOBILE } from '@modules/page-builder/config/column-constants';
import {
    PADDING_LEFT_RIGHT_SECTION,
    PADDING_LEFT_RIGHT_SECTION_MOBILE,
} from '@modules/page-builder/component/common/pagebuilder.style';

export const TrioImageModuleContainer: StyleRule = ({ theme }) => ({
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    width: '100%',
    padding: `0 ${pxToRem(PADDING_LEFT_RIGHT_SECTION_MOBILE)}`,

    [theme.screen.laptop]: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        columnGap: pxToRem(32),
        gridTemplateRows: `1fr`,
        width: '100%',
        maxWidth: '100%',
        margin: '0 auto',
        justifyItems: 'center',
        padding: `0 ${pxToRem(PADDING_LEFT_RIGHT_SECTION)}`,
    },
});

export const TrioImageContainerImage: (isMedium: boolean) => StyleRule<{
    columns: number;
    mobile: boolean;
}> =
    (isMedium) =>
    ({ columns, mobile, theme }) => {
        if (isMedium && !mobile) {
            return { margin: '0 auto' };
        }

        if (mobile) {
            return Object.assign({
                margin: '0 auto',
                '&:last-child':
                    columns > 1
                        ? {
                              margin: `${pxToRem(ROW_GAP_MOBILE)} auto 0`,
                          }
                        : undefined,
            });
        }
        return {
            margin: `${pxToRem(ROW_GAP_MOBILE)} auto 0`,
            [theme.screen.laptop]: {
                margin: 'auto',
                '&:has(.isMedium)': {
                    margin: '0 auto',
                },
            },
        };
    };
